import Collector from './Collector';

export default Collector;
